import {RouteParams, RoutePath} from "@/router/RoutingModels";

export function buildRoute<R extends keyof RouteParams>(
    route: R,
    ...args: RouteParams[R] extends undefined ? [] : [params: RouteParams[R]]
): string {

    let path = RoutePath[route];

    if ( !path ) {
        return "/404#invalid_path_scope";
    }

    if (!args.length) return path;

    const params = args[0]!;
    Object.entries(params).forEach(([key, value]) => {
        path = path.replace(`:${key}`, encodeURIComponent(String(value)));
    });

    return path;
}

export function buildLinkUrl(path?: string | null) {
    if (!path) {
        return "#invalid";
    }

    if (path.startsWith("//") || path.startsWith("http") || path.startsWith("<svg")) {
        return path;
    }

    return buildRoute(path as any);
}